import React from 'react';
import PropTypes from 'prop-types';
import Title from './title';
import Description from './description';
import Image from './image';
import Facebook from './facebook';
import Twitter from './twitter';

const Seo = ({ title, description, image, facebook, twitter }) => (
  <span>
    {
      title &&
        <Title>
          {title}
        </Title>
    }
    {
      description &&
        <Description>
          {description}
        </Description>
    }
    {
      image &&
        <Image>
          {image}
        </Image>
    }
    {
      facebook &&
        <Facebook {...facebook} />
    }
    {
      twitter &&
        <Twitter {...twitter} />
    }
  </span>
);

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  facebook: PropTypes.shape({
    siteName: PropTypes.string,
    userId: PropTypes.string,
    appId: PropTypes.string,
  }),
  twitter: PropTypes.shape({
    handle: PropTypes.string,
  }),
};

Seo.defaultProps = {
  title: null,
  description: null,
  image: null,
  facebook: null,
  twitter: null,
};

Seo.Title = Title;
Seo.Description = Description;
Seo.Image = Image;

export default Seo;



// WEBPACK FOOTER //
// ./src/app/components/seo/index.js